export function encodePayload(obj: any): string {
  try {
    const json = JSON.stringify(obj)
    // Handle unicode characters correctly by using TextEncoder
    const utf8Bytes = new TextEncoder().encode(json)
    let binary = ""
    for (let i = 0; i < utf8Bytes.length; i++) {
      binary += String.fromCharCode(utf8Bytes[i])
    }
    const base64 = btoa(binary)
    // Make it URL safe
    return "_data_" + base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
  } catch (err) {
    console.error("Error encoding payload:", err)
    return ""
  }
}

export function decodePayload<T = any>(token: string): T | null {
  if (!token || !token.startsWith("_data_")) return null
  try {
    let base64 = token.substring(6)
    // Restore URL-safe characters
    base64 = base64.replace(/-/g, '+').replace(/_/g, '/')
    while (base64.length % 4) {
      base64 += '='
    }
    const binary = atob(base64)
    const bytes = new Uint8Array(binary.length)
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i)
    }
    const json = new TextDecoder().decode(bytes)
    return JSON.parse(json) as T
  } catch (err) {
    console.error("Error decoding payload:", err)
    return null
  }
}
